function toFiniteNumericValue(value) {
  if (
    value == null ||
    typeof value === "boolean" ||
    (typeof value === "string" && value.trim() === "") ||
    (typeof value !== "number" && typeof value !== "string")
  ) {
    return null;
  }

  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : null;
}

export function formatCurrency(value, locale = undefined, currency = undefined) {
  const numeric = toFiniteNumericValue(value);
  const normalizedCurrency =
    typeof currency === "string" ? currency.trim().toUpperCase() : "";
  if (numeric == null || !/^[A-Z]{3}$/.test(normalizedCurrency)) return "\u2014";

  try {
    return numeric.toLocaleString(locale, {
      style: "currency",
      currency: normalizedCurrency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  } catch (_error) {
    return `${numeric.toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} ${normalizedCurrency}`;
  }
}

export function formatNumber(value, decimals = 2, locale = undefined) {
  const numeric = toFiniteNumericValue(value);
  if (numeric == null) return "\u2014";
  return numeric.toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export function formatPercent(value, decimals = 1, locale = undefined) {
  const numeric = toFiniteNumericValue(value);
  if (numeric == null) return "\u2014";
  return `${(numeric * 100).toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}%`;
}

export function formatDateLabel(value, locale = "en-GB") {
  if (!value) return "\u2014";
  const date = new Date(`${String(value).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString(locale, {
    weekday: "short",
    day: "2-digit",
    month: "short",
  });
}

export function formatDateRange(dateFrom, dateTo, locale = undefined) {
  if (!dateFrom || !dateTo) return "\u2014";
  if (!locale) {
    return `${String(dateFrom).slice(0, 10)} -> ${String(dateTo).slice(0, 10)}`;
  }
  const from = new Date(`${String(dateFrom).slice(0, 10)}T00:00:00`);
  const to = new Date(`${String(dateTo).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) {
    return `${String(dateFrom).slice(0, 10)} -> ${String(dateTo).slice(0, 10)}`;
  }
  return `${from.toLocaleDateString(locale)} -> ${to.toLocaleDateString(locale)}`;
}

export function toSortedUniqueDates(rows, fieldName = "stay_date") {
  const dates = new Set();
  (rows || []).forEach((row) => {
    const value = String(row?.[fieldName] || "").slice(0, 10);
    if (value) dates.add(value);
  });
  return Array.from(dates).sort((left, right) => left.localeCompare(right));
}

export function safeArray(value) {
  return Array.isArray(value) ? value : [];
}

export function statusTone(status) {
  const normalized = String(status || "").toLowerCase();
  if (normalized === "ok" || normalized === "active" || normalized === "true") {
    return "success";
  }
  if (normalized === "error" || normalized === "inactive" || normalized === "false") {
    return "danger";
  }
  if (normalized === "running" || normalized === "pending" || normalized === "warning") {
    return "warn";
  }
  return "soft";
}
